import { useMutation } from '@apollo/client';

import addFormAnswerMutation from '../../requests/mutations/addFormAnswer';
import updateFormAnswerMutation from '../../requests/mutations/updateFormAnswer';
import submitFormAnswerMutation from '../../requests/mutations/submitFormAnswer';
import updateXFormAnswerMutation from '../../requests/mutations/updateXFormAnswer';
import submitXFormAnswerMutation from '../../requests/mutations/submitXFormAnswer';

export function useAddFormAnswerMutation(refetch) {
  const [addFormAnswer] = useMutation(addFormAnswerMutation);

  return addFormAnswer;
}

export function useUpdateFormAnswerMutation(refetch) {
  const [updateFormAnswer] = useMutation(updateFormAnswerMutation);

  return updateFormAnswer;
}

export function useSubmitFormAnswerMutation(refetch) {
  const [submitFormAnswer] = useMutation(submitFormAnswerMutation, {
    onCompleted: () => refetch && refetch()
  });

  return submitFormAnswer;
}

export function useCompleteXFormAnswer() {
  const [updateXFormAnswer] = useMutation(updateXFormAnswerMutation);
  const [submitXFormAnswer] = useMutation(submitXFormAnswerMutation);

  return async (options) => {
    const result = await updateXFormAnswer(options);
    const { formAnswerXuid } = options.variables;
    await submitXFormAnswer({ variables: { formAnswerXuid, state: 'submitted' } });
    return result;
  };
}
